export const categories = [
  { id: 'all', name: '全部', desc: '所有正在追踪的热点线索', icon: 'ri-layout-grid-line' },
  { id: 'event', name: '热点事件', desc: '集中发酵的公共话题与后续回应', icon: 'ri-alarm-warning-line' },
  { id: 'variety', name: '综艺动态', desc: '节目改版、录制路透与赛制讨论', icon: 'ri-live-line' },
  { id: 'drama', name: '影视风向', desc: '剧集选角、拍摄进度与口碑走向', icon: 'ri-movie-2-line' },
  { id: 'music', name: '音乐现场', desc: '音乐节、巡演与开票规则变化', icon: 'ri-music-2-line' },
  { id: 'net', name: '网络话题', desc: '二创风潮、平台玩法与版权讨论', icon: 'ri-chat-smile-2-line' },
];

export const topics = [
  {
    slug: 'music-festival-lineup',
    title: '年度户外音乐节阵容传闻追踪',
    summary:
      '从网传拟邀名单到主办方首次回应，本篇持续跟进阵容公布节奏、开票时间与场地动线调整，把每一次更新都记在同一时间线上。',
    category: 'music',
    categoryName: '音乐现场',
    status: '跟进中',
    heat: 9860,
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20abstract%20outdoor%20music%20festival%20stage%20at%20night%20with%20warm%20crimson%20and%20amber%20stage%20lights%2C%20blurred%20crowd%20silhouettes%2C%20moody%20editorial%20magazine%20style%2C%20high%20detail%2C%20no%20text%2C%20wide%20composition&width=1200&height=800&seq=kl-topic-music-festival&orientation=landscape',
    publishedAt: '2026-08-21',
    updatedAt: '2026-09-11',
    tags: ['音乐节', '阵容名单', '开票时间'],
    highlights: ['拟邀名单首次流出', '主办方回应“仍在沟通”', '开票时间推迟一周'],
    updates: [
      { date: '2026-08-21', title: '拟邀名单在社交平台流传', content: '一份标注“内部沟通稿”的拟邀名单被大量转发，名单按舞台分为三个时段，但未出现官方标识。', tag: '线索' },
      { date: '2026-08-29', title: '主办方首次回应', content: '主办方发布说明，表示阵容仍在沟通阶段，名单并非最终版本，提醒观众以官方渠道为准。', tag: '回应' },
      { date: '2026-09-05', title: '开票时间推迟一周', content: '原定开票日被顺延，官方解释为配合场地动线复核与安检方案升级，早鸟票权益保持不变。', tag: '更新' },
      { date: '2026-09-11', title: '首批阵容官宣', content: '官方公布首批十二组艺人，与此前流传名单重合度约六成，剩余阵容将分两批公布。', tag: '进展' },
    ],
    body: [
      '户外音乐节的阵容往往在正式官宣前就经历多轮“流传—回应—修正”的过程。看料社把这条线索拆成可追溯的节点，让你不必在零散截图里反复寻找同一件事的不同版本。',
      '从目前公开信息看，今年的变动主要集中在开票节奏与场地动线上：一方面主办方希望留出更充裕的报批时间，另一方面也在调整入场分流的方案，减少瞬时人流压力。',
      '需要提醒的是，任何未标注官方来源的名单都应保持审慎。本条追踪会持续记录每一次官方口径的变化，并在时间线上标明信息来源的可信度。',
    ],
  },
  {
    slug: 'period-drama-casting',
    title: '古装大剧《长安夜行》选角调整跟进',
    summary:
      '项目从立项到开机经历了两次主要角色调整，本篇整理官方通稿、剧组公告与拍摄进度，还原选角变化的完整脉络。',
    category: 'drama',
    categoryName: '影视风向',
    status: '有新进展',
    heat: 8740,
    cover:
      'https://readdy.ai/api/search-image?query=Abstract%20ancient%20chinese%20palace%20corridor%20at%20dusk%20with%20deep%20crimson%20lanterns%20and%20golden%20light%2C%20silhouetted%20architecture%2C%20moody%20editorial%20poster%20style%2C%20high%20detail%2C%20no%20text%2C%20wide%20composition&width=1200&height=800&seq=kl-topic-period-drama&orientation=landscape',
    publishedAt: '2026-07-30',
    updatedAt: '2026-09-09',
    tags: ['古装剧', '选角', '开机'],
    highlights: ['主角阵容首次公布', '男二号更替', '剧组发布拍摄进度说明'],
    updates: [
      { date: '2026-07-30', title: '项目正式官宣', content: '制作方发布概念海报与主创名单，宣布进入前期筹备，预计秋季开机。', tag: '线索' },
      { date: '2026-08-14', title: '男二号角色更替', content: '剧组公告称因档期协调原因更换男二号演员，已完成的定妆与围读将重新安排。', tag: '更新' },
      { date: '2026-09-09', title: '拍摄进度说明', content: '剧组发布进度说明，表示已完成主要场景勘景，进入集中拍摄阶段，未提及播出时间。', tag: '进展' },
    ],
    body: [
      '一部大体量古装剧从官宣到开机，往往要经过选角、定妆、围读、勘景等一连串环节，任何一环的调整都会牵动后续排期。',
      '本条追踪只记录有明确来源的信息：官方通稿、剧组公告以及公开的拍摄进度说明。对于仅有“知情人士”表述的内容，我们会在时间线中单独标注，不做推定。',
      '目前该项目已进入集中拍摄阶段，后续值得关注的节点包括首支预告发布、平台定档与正式更名等。',
    ],
  },
  {
    slug: 'variety-reboot',
    title: '老牌综艺改版回归：模式调整与录制路透',
    summary:
      '停播一年后节目宣布改版回归，本篇跟进赛制变化、常驻嘉宾名单与首轮录制反馈。',
    category: 'variety',
    categoryName: '综艺动态',
    status: '跟进中',
    heat: 7620,
    cover:
      'https://readdy.ai/api/search-image?query=Abstract%20television%20studio%20set%20with%20warm%20amber%20spotlights%20and%20deep%20crimson%20backdrop%2C%20geometric%20stage%20elements%2C%20moody%20editorial%20style%2C%20high%20detail%2C%20no%20text%2C%20wide%20composition&width=1200&height=800&seq=kl-topic-variety-reboot&orientation=landscape',
    publishedAt: '2026-08-06',
    updatedAt: '2026-09-10',
    tags: ['综艺', '改版', '录制'],
    highlights: ['宣布改版回归', '赛制由竞演转为合作', '首轮录制完成'],
    updates: [
      { date: '2026-08-06', title: '节目宣布改版回归', content: '官方账号发布先导片，确认节目将以全新模式回归，保留经典环节但调整评分机制。', tag: '线索' },
      { date: '2026-08-24', title: '赛制由竞演转为合作', content: '制作团队在媒体沟通会上表示，新一季弱化淘汰设定，改为分组合作完成长线任务。', tag: '更新' },
      { date: '2026-09-10', title: '首轮录制完成', content: '首轮录制结束，现场观众反馈录制时长明显增加，节目组称将根据反馈调整剪辑节奏。', tag: '进展' },
    ],
    body: [
      '老牌综艺的改版往往伴随着观众预期管理：既要保留记忆点，又要给出新鲜感。本季最大的变化是弱化了淘汰带来的紧张感，转向长线合作。',
      '从首轮录制的公开反馈看，观众最关心的依然是节奏与剪辑。节目组已表示会依据现场反馈做出调整，这也让“剪辑版本”成为接下来值得追踪的节点。',
    ],
  },
  {
    slug: 'trainee-show-rules',
    title: '团体选拔节目赛制讨论持续发酵',
    summary:
      '投票权重、淘汰规则与导师话语权成为讨论焦点，本篇整理节目组说明与此后的规则微调。',
    category: 'variety',
    categoryName: '综艺动态',
    status: '有新进展',
    heat: 8150,
    cover:
      'https://readdy.ai/api/search-image?query=Abstract%20stage%20with%20rows%20of%20warm%20amber%20lights%20and%20deep%20crimson%20curtains%2C%20empty%20stage%20floor%2C%20moody%20editorial%20photography%20style%2C%20high%20detail%2C%20no%20text%2C%20wide%20composition&width=1200&height=800&seq=kl-topic-trainee-show&orientation=landscape',
    publishedAt: '2026-07-18',
    updatedAt: '2026-09-08',
    tags: ['选拔节目', '赛制', '投票'],
    highlights: ['首轮投票权重公布', '观众质疑规则透明度', '节目组补充说明'],
    updates: [
      { date: '2026-07-18', title: '首轮投票权重公布', content: '节目公布首轮投票构成，观众票、导师票与现场评审票各占一定比例，具体折算方式同步公开。', tag: '线索' },
      { date: '2026-08-20', title: '观众质疑规则透明度', content: '部分观众对导师票的折算方式提出疑问，相关话题在社交平台持续升温。', tag: '讨论' },
      { date: '2026-09-08', title: '节目组补充说明', content: '节目组发布补充说明，公布每一轮的具体折算公式，并表示后续将新增数据公示页。', tag: '回应' },
    ],
    body: [
      '选拔类节目最容易引发讨论的从来不是舞台，而是规则。当投票构成与折算方式不够直观时，观众会本能地寻求解释。',
      '本轮的进展是节目组选择公开折算公式并增设数据公示页，这在一定程度上缓解了讨论。接下来值得关注的是公示页的更新频率是否稳定。',
    ],
  },
  {
    slug: 'autumn-film-festival',
    title: '秋季电影展获奖名单与口碑走向',
    summary:
      '影展落幕后的讨论并未停止，本篇跟进获奖影片的排片变化、观众口碑与后续放映计划。',
    category: 'drama',
    categoryName: '影视风向',
    status: '已归档',
    heat: 6410,
    cover:
      'https://readdy.ai/api/search-image?query=Abstract%20cinema%20auditorium%20with%20warm%20amber%20screen%20glow%20and%20deep%20crimson%20seats%2C%20empty%20rows%2C%20moody%20editorial%20style%2C%20high%20detail%2C%20no%20text%2C%20wide%20composition&width=1200&height=800&seq=kl-topic-film-festival&orientation=landscape',
    publishedAt: '2026-06-28',
    updatedAt: '2026-08-30',
    tags: ['电影展', '获奖', '口碑'],
    highlights: ['获奖名单公布', '影展加映两场', '线上口碑分化'],
    updates: [
      { date: '2026-06-28', title: '获奖名单公布', content: '影展公布本届获奖名单，评审团特别提及纪录单元的整体质量。', tag: '线索' },
      { date: '2026-07-15', title: '影展加映两场', content: '因购票需求集中，组委会临时加映两场获奖影片，并延长了线上访谈的回放时间。', tag: '更新' },
      { date: '2026-08-30', title: '线上口碑分化', content: '影片上线后口碑出现分化，讨论集中在叙事节奏与配乐使用上，本条追踪至此归档。', tag: '归档' },
    ],
    body: [
      '影展的价值不止于颁奖当晚，更在于它能否把讨论延续到影片真正与更多观众见面的时刻。',
      '本届获奖影片在院线与线上呈现出不同的口碑曲线，这本身也是值得记录的行业现象。本条线索已进入归档状态，页面保留全部节点供查阅。',
    ],
  },
  {
    slug: 'short-video-remix',
    title: '短视频二创风潮：从爆火到版权讨论',
    summary:
      '一个二创模板带火一类内容后，授权边界与平台规则随之成为话题，本篇跟进规则变化与创作者反应。',
    category: 'net',
    categoryName: '网络话题',
    status: '跟进中',
    heat: 7290,
    cover:
      'https://readdy.ai/api/search-image?query=Abstract%20glowing%20screen%20grid%20with%20warm%20amber%20and%20crimson%20particles%2C%20dark%20digital%20texture%2C%20moody%20editorial%20style%2C%20high%20detail%2C%20no%20text%2C%20wide%20composition&width=1200&height=800&seq=kl-topic-short-video&orientation=landscape',
    publishedAt: '2026-08-02',
    updatedAt: '2026-09-07',
    tags: ['二创', '版权', '平台规则'],
    highlights: ['模板玩法走红', '原创方发布授权说明', '平台更新二创规则'],
    updates: [
      { date: '2026-08-02', title: '模板玩法走红', content: '一套低成本的转场模板在短时间内被大量使用，相关话题进入热门榜。', tag: '线索' },
      { date: '2026-08-19', title: '原创方发布授权说明', content: '原始素材创作者发布说明，明确可商用与不可商用的边界，并提供授权申请入口。', tag: '回应' },
      { date: '2026-09-07', title: '平台更新二创规则', content: '平台更新二创内容规范，新增素材来源标注要求，并上线侵权举报快捷通道。', tag: '更新' },
    ],
    body: [
      '二创的传播效率极高，但它天然处在“灵感共享”与“授权边界”的模糊地带。当一个模板成为公共习惯，规则的补位往往就会迟到。',
      '本次的进展是原创方主动给出授权说明，平台同步更新规范。对创作者而言，最实际的变化是素材来源需要标注，且商用需要单独申请。',
    ],
  },
  {
    slug: 'concert-tour-rules',
    title: '巡演加场与退票规则变化追踪',
    summary:
      '多城巡演陆续加场，退票与实名规则同步调整，本篇整理各站开票信息与规则差异。',
    category: 'music',
    categoryName: '音乐现场',
    status: '跟进中',
    heat: 6980,
    cover:
      'https://readdy.ai/api/search-image?query=Abstract%20concert%20arena%20with%20warm%20amber%20laser%20beams%20and%20deep%20crimson%20haze%2C%20empty%20stage%20platform%2C%20moody%20editorial%20style%2C%20high%20detail%2C%20no%20text%2C%20wide%20composition&width=1200&height=800&seq=kl-topic-concert-tour&orientation=landscape',
    publishedAt: '2026-08-11',
    updatedAt: '2026-09-06',
    tags: ['巡演', '加场', '退票规则'],
    highlights: ['首站开票售罄', '追加两场演出', '退票窗口缩短'],
    updates: [
      { date: '2026-08-11', title: '首站开票售罄', content: '首站门票开售即告售罄，官方提示以实名制方式购票，禁止转让。', tag: '线索' },
      { date: '2026-08-26', title: '追加两场演出', content: '主办方宣布在首站城市追加两场，开票时间与实名规则与首场保持一致。', tag: '更新' },
      { date: '2026-09-06', title: '退票窗口缩短', content: '官方更新退票规则，将可退票窗口由演出前七天缩短至三天，退票手续费维持不变。', tag: '更新' },
    ],
    body: [
      '巡演加场通常伴随购票规则同步收紧，尤其是实名与退票窗口，这两项直接关系到观众的实际权益。',
      '本次规则变化中，争议最大的是退票窗口的缩短。官方解释为配合票务系统与场地方的核验安排，观众在购票前应仔细阅读对应城市的规则说明。',
    ],
  },
  {
    slug: 'livestream-followup',
    title: '直播连麦后续：各方回应与平台动作',
    summary:
      '一场直播连麦引发广泛讨论后，当事人、平台与品牌方先后作出回应，本篇汇总可核实的时间线。',
    category: 'event',
    categoryName: '热点事件',
    status: '有新进展',
    heat: 9210,
    cover:
      'https://readdy.ai/api/search-image?query=Abstract%20broadcast%20studio%20with%20warm%20crimson%20and%20amber%20light%20panels%2C%20microphone%20stand%20silhouette%2C%20moody%20editorial%20style%2C%20high%20detail%2C%20no%20text%2C%20wide%20composition&width=1200&height=800&seq=kl-topic-livestream&orientation=landscape',
    publishedAt: '2026-08-27',
    updatedAt: '2026-09-12',
    tags: ['直播', '回应', '平台规范'],
    highlights: ['连麦片段被大量转发', '当事人发布说明', '平台上线提示机制'],
    updates: [
      { date: '2026-08-27', title: '连麦片段被大量转发', content: '一段直播连麦片段在多个平台被转发，讨论迅速升温，出现不同版本的剪辑。', tag: '线索' },
      { date: '2026-09-02', title: '当事人发布说明', content: '相关当事人发布书面说明，呼吁停止传播未经核实的剪辑，并表示将通过正规渠道沟通。', tag: '回应' },
      { date: '2026-09-12', title: '平台上线提示机制', content: '平台宣布在相关话题下新增内容提示与来源标注要求，同时清理违规剪辑内容。', tag: '更新' },
    ],
    body: [
      '热点事件的信息传播往往快于核实，剪辑版本越多，还原事实的难度就越高。本篇只收录有明确发布主体的内容。',
      '目前已知的动作包括当事人发布书面说明、平台上线内容提示机制。后续值得关注的节点是相关方是否会公布进一步的沟通结果。',
    ],
  },
];